import { IntersectionType } from '@nestjs/swagger';
import { Exclude } from 'class-transformer';
import { BuilderInterface } from '../../builder/interfaces/builder.interface';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobInterface } from '../../job/interfaces/job.interface';
import { SubdivisionInterface } from '../../subdivision/interfaces/subdivision.interface';
import { SupplierInterface } from '../../supplier/interfaces/supplier.interface';
import { ScheduledEmailsDailySupplierInterface } from '../interfaces/scheduled-emails-daily-supplier.interface';

@Exclude()
export class ScheduledEmailsDailySupplierDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements ScheduledEmailsDailySupplierInterface
{
  jobId!: string;
  jobLot!: string;
  jobBlock!: string;
  builderId!: string;
  builderName!: string;
  modelName!: string;
  subdivisionId!: string;
  subdivisionName!: string;
  supervisorUserIds!: string;
  supervisorFullNames!: string;
  orderNumber!: string;
  orderDate?: Date | undefined;
  supplierName!: string;
  address1!: string;
  address2!: string;
  city!: string;
  state!: string;
  zip!: string;
  username!: string;
  representativeFirstName!: string;
  representativeLastName!: string;
  job?: JobInterface | undefined;
  subdivision?: SubdivisionInterface | undefined;
  builder?: BuilderInterface | undefined;
  supplierId!: string;
  supplier?: SupplierInterface | undefined;
}
